"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const replaySchema_1 = require("./replaySchema");
class DurableOrchestrationBindingInfoReqFields {
    constructor(history = [], instanceId = "", isReplaying = false, upperSchemaVersion = replaySchema_1.ReplaySchema.V1) {
        this.history = history;
        this.instanceId = instanceId;
        this.isReplaying = isReplaying;
        this.upperSchemaVersion = upperSchemaVersion;
    }
}
exports.DurableOrchestrationBindingInfoReqFields = DurableOrchestrationBindingInfoReqFields;
class DurableOrchestrationBindingInfo extends DurableOrchestrationBindingInfoReqFields {
    constructor(history = [], input, instanceId = "", isReplaying = false, parentInstanceId, maximumShortTimerDuration, longRunningTimerIntervalDuration, defaultHttpAsyncRequestSleepTimeMillseconds, upperSchemaVersion = replaySchema_1.ReplaySchema.V1) {
        super(history, instanceId, isReplaying, upperSchemaVersion);
        this.history = history;
        this.input = input;
        this.instanceId = instanceId;
        this.isReplaying = isReplaying;
        this.parentInstanceId = parentInstanceId;
        this.maximumShortTimerDuration = maximumShortTimerDuration;
        this.longRunningTimerIntervalDuration = longRunningTimerIntervalDuration;
        this.defaultHttpAsyncRequestSleepTimeMillseconds = defaultHttpAsyncRequestSleepTimeMillseconds;
        this.upperSchemaVersion = upperSchemaVersion;
    }
}
exports.DurableOrchestrationBindingInfo = DurableOrchestrationBindingInfo;
//# sourceMappingURL=durableorchestrationbindinginfo.js.map